import React, { memo } from "react";

import { IBenefitWrapperProps } from "../types";

import { isEmpty } from "@swiggy-private/core-ui";

import Benefit from "./Benefit";

import styles from "../styles/OfferPackNudgeWidget.scss";

const BenefitWrapper = ({ benefits }: IBenefitWrapperProps) => {
    if (isEmpty(benefits)) return null;

    return (
        <div className={styles.benefitWrapper}>
            {benefits.map((benefit, index) => (
                <Benefit {...benefit} key={index} />
            ))}
        </div>
    );
};

export default memo(BenefitWrapper);
